import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import {setContext} from "apollo-link-context/lib/index";

const httpLink = new HttpLink({
  uri: process.env.GRAPHQL_URI
});

const authLink = setContext((_, { headers }) => {
  const auth = JSON.parse(localStorage.getItem('auth')) || {};

  return {
    headers: {
      ...headers,
      authorization: auth.token || '',
    },
  };
});


// Create the apollo client
export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  connectToDevTools: true
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

// Install the vue plugin
Vue.use(VueApollo);

export default apolloProvider


// WEBPACK FOOTER //
// ./src/apollo.js